import React from 'react';
import { PageMenuDrawerContext } from './PageMenuDrawerContext';
const usePageMenuDrawer = () => React.useContext(PageMenuDrawerContext);
export default usePageMenuDrawer;
